export default "__VITE_ASSET__6xffDf4l__"